import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./Pages.css";

const ProductsIndustries = () => {
  const products = [
    {
      title: "Targeted Data Packages",
      items: [
        "U.S. account and Contact coverage",
        "Role-based buying committee mapping",
        "Intent and Fit signal layering",
      ],
    },
    {
      title: "Campaign Acceleration Kits",
      items: [
        "Outbound playbooks and Messaging blocks",
        "Channel sequencing templates",
        "Performance reporting dashboards",
      ],
    },
    {
      title: "RevOps Blueprint Modules",
      items: [
        "Lead lifecycle and Routing logic",
        "Sales-marketing SLA framework",
        "Conversion and Funnel KPI model",
      ],
    },
  ];

  const industries = [
    "SaaS and Technology",
    "Healthcare and Professional services",
    "Financial and Business services",
    "Manufacturing and Logistics",
  ];

  return (
    <main>
      <Helmet>
        <title>Products &amp; Industries | ThinkRise USA</title>
        <meta
          name="description"
          content="Browse ThinkRise USA product suites and industry programs, from targeted data packages to campaign kits and RevOps blueprints for U.S. growth teams."
        />
      </Helmet>
      <section className="page-hero products-hero">
        <div className="container">
          <h1 className="page-hero-title">Products and Industries</h1>
          <p className="page-hero-subtitle">
            Explore the growth assets and industry programs ThinkRise USA uses to drive measurable pipeline outcomes.
          </p>
          <Link to="/contact" className="btn">Get a Custom Package</Link>
        </div>
      </section>

      <section className="section products-section-clean">
        <div className="container">
          <h2 className="section-title">Product Suites</h2>
          <div className="products-grid-clean">
            {products.map((product) => (
              <article key={product.title} className="product-card-clean">
                <h3>{product.title}</h3>
                <ul>
                  {product.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section industries-section-clean">
        <div className="container">
          <h2 className="section-title">Industries We Support</h2>
          <div className="industries-pill-grid">
            {industries.map((industry) => (
              <div key={industry} className="industry-pill-card">{industry}</div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default ProductsIndustries;
